module.exports = function getResource(label, vars = []) {
    const resources = {
        free: 'FREE',
        warning: 'Warning',
        shippingMethodError: `Unfortunately, we can only ship to your address using ${vars[0]}. Please select this method or choose a different address on the Apple Pay sheet.`
    };

    return resources[label];
};
